/**
 * Skills Management Page
 * 
 * Provides a dedicated page for managing the hierarchical skill taxonomy.
 * Accessible from the main navigation menu.
 */

import React from 'react';
import { SkillManager } from '../components/Skills/SkillManager';
import './SkillsPage.css';

export const SkillsPage: React.FC = () => {
  return (
    <div className="skills-page">
      <div className="skills-page-container">
        <SkillManager />
      </div>
    </div>
  );
};

export default SkillsPage;


